import * as actionTypes from "./bodyDrawerActions";

export const clickTab = (tabName) => {
  return { type: actionTypes.TAB_CLICKED, tabName: tabName };
};

export const backClicked = () => {
  return {
    type: actionTypes.BACK_CLICKED,
  };
};
